import { render, staticRenderFns } from "./birimbazlihedefgerceklesmetoplamlaritablosu.vue?vue&type=template&id=29a77632"
import script from "./birimbazlihedefgerceklesmetoplamlaritablosu.vue?vue&type=script&lang=js"
export * from "./birimbazlihedefgerceklesmetoplamlaritablosu.vue?vue&type=script&lang=js"
import style0 from "./birimbazlihedefgerceklesmetoplamlaritablosu.vue?vue&type=style&index=0&id=29a77632&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports